import { StateService } from "@uirouter/angularjs";
import { UserProfile } from "../../application/UserProfile";
import { AuthorizedUiElementConfig } from "./authorizedUiElementConfig";
import { sortBy } from "lodash";

export class AuthorizedUiElementService<
  TAuthorizedUiElementConfig extends AuthorizedUiElementConfig
> {
  constructor(
    protected readonly userProfile: UserProfile,
    protected readonly configs: TAuthorizedUiElementConfig[],
    protected readonly $state: StateService,
    protected readonly basePath: string
  ) {
    this.configs = sortBy(configs, (c) => c.order ?? 0);
  }

  getSref(config: TAuthorizedUiElementConfig): string {
    if (!config.uiSrefFragment) throw new Error("null sref");

    return config.absoluteSref
      ? config.uiSrefFragment
      : `${this.basePath}.${config.uiSrefFragment}`;
  }

  getSrefByIndex(index: number = 0) {
    const tab = this.getConfig(index);
    return this.getSref(tab);
  }

  navigateToChildByIndex(index: number = 0, params?: any, reload?: boolean) {
    return this.navigateToChild(this.getConfig(index), params, reload);
  }

  navigateToChild(
    config: TAuthorizedUiElementConfig,
    params?: any,
    reload?: boolean
  ) {
    const uiSref = this.getSref(config);
    return this.$state.go(uiSref, params, { reload });
  }

  getConfigs(): TAuthorizedUiElementConfig[] {
    return this.configs.filter(
      (s) =>
        s.requiredPermission === undefined ||
        this.userProfile.hasPermission(s.requiredPermission)
    );
  }

  getConfig(index: number) {
    const tabs = this.getConfigs();
    index = Math.min(Math.max(0, index), tabs.length - 1);
    return tabs[index];
  }
}
